module.exports = __webpack_public_path__ + "img/newapalylogowhite.bd3b3b72.png";